//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../components/footer.vue'
import {
    MemberWarningCardUsedQuery
} from '../../static/js/api.js'


function loadtotal(that) {






    var data = {
        StrStartDate: that.value1+" 00:00:00",
        StrEndDate: that.value2+" 23:59:59",

        MoneyThreshold:that.value3,
        RefillCount:that.value4,
        CheckoutCount:that.value5
    }
    console.log(data)
    MemberWarningCardUsedQuery(data, function (res) {

        if (res.data.IsSuccess) {

            that.data = JSON.parse(res.data.Result)
            console.log(that.data)
        } else {

            that.$vux.toast.text('数据获取失败，请重试', 'middle')

        }


    })

}

export default {
    name: 'app',
    components: {
        'pc-footer': Footer,
    },
    data() {
        return {

            loading: true,

            data: {
                CardWarening: {}

            },
            value1: '',
            value2: '',
            value3: 10,
            value4: 3,
            value5: 10,
            msg: 'Welcome to Your Vue.js App',
            showContent001: false,
            showContent002: false,
            showContent003: false,
            showContent004: false,
            showContent005: false,
            showContent006: false,
            showContent007: false,
            showContent008: false,
            selected: 1,

            nav: [
                {
                    id: 1,
                    name: "会员卡消费异常信息"

                },


            ],
        }
    },
    created() {
        var that = this

        
        var dates=new Date()
        var years = dates.getFullYear()//当前年
        var months = (dates.getMonth() + 1) <10? "0" + ((dates.getMonth() + 1) + '') : (dates.getMonth() + 1) //当前月份

        var days = dates.getDate()<10?"0" + (dates.getDate()+"") :dates.getDate() //当天


        var d = new Date();
        d.setDate(d.getDate() - 1);
        var yy1 = d.getFullYear();
        var mm1 = d.getMonth() + 1;//因为getMonth（）返回值是 0（一月） 到 11（十二月） 之间的一个整数。所以要给其加1
        var dd1 = d.getDate();
        if (mm1 < 10) {
            mm1 = '0' + mm1;
        }
        if (dd1 < 10) {
            dd1 = '0' + dd1;
        }
        that.value2=yy1+'-'+mm1+'-'+dd1
        that.value1=yy1+'-'+mm1+'-'+dd1

        loadtotal(that)


    },
    methods: {

        onConfirm1(val) {
            this.value1 = val

        },
        onConfirm2(val) {
            this.value2 = val
        },
        refresh() {
            this.loading = true
            var that = this
            loadtotal(that)


        },
        change(index) {
            console.log(index)
            this.selected = parseInt(index + 1)

        },
        search() {

            var that = this

            this.loading = true
            loadtotal(that)

        },
        dateFormat: function (time) {
            var date = new Date(time);
            var year = date.getFullYear();
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/hjyichangcard.vue